export const addPossibleAnswerAction = function (item) {
    return {
        type: "FB_ADD_POSSIBLE_ANSWER",
        payload: item
    }
};

export const setPossibleAnswersAction = function (items) {
    return {
        type: "FB_SET_POSSIBLE_ANSWERS",
        payload: items
    }
};

export const removePossibleAnswerAction = function (item) {
    return {
        type: "FB_REMOVE_POSSIBLE_ANSWER",
        payload: item
    }
};

export const clearPossibleAnswersAction = function () {
    return {
        type: "FB_CLEAR_POSSIBLE_ANSWERS"
    }
};

export const changePossibleAnswerAction = function (item) {
    return {
        type: "FB_CHANGE_POSSIBLE_ANSWER",
        payload: item
    }
};


// WEBPACK FOOTER //
// ./src/redux/creators/form-builder/possibleAnswers.js